<template>
    <div class="price-container">
        <!-- nodisclosureDes not equal to null hour ， Forced to price add mosaic ( only for Pocket listing of listings ) -->
        <template v-if="!showSoldPrice && !showListingPrice">
            <no-disclosure :des="cmpNondisclosureDes"></no-disclosure>
        </template>
        <template v-else-if="showSoldPrice && showListingPrice">
            <div class="first-price">
                {{ $ft.formatCurrency({ value: info.soldPrice, noSpace: true, currencySymbol}) }}
            </div>
            <div class="second-price">
                {{ $ft.formatCurrency({ value: info.price, noSpace: true, currencySymbol}) }}
            </div>
            <span
                v-if="trend"
                class="trend"
                :class="{
                    up: info.soldPrice > info.price,
                    down: info.soldPrice < info.price
                }"
            >
                <span class="iconfont icon-expand"></span>
                {{ trend }}
            </span>
        </template>
        <template v-else>
            <div class="first-price">
                {{
                    $ft.formatCurrency({
                        value: showSoldPrice ? info.soldPrice : info.price,
                        noSpace: true,
                        currencySymbol
                    })
                }}
            </div>
        </template>
    </div>
</template>
<script>
import price from "../_mixins/price"
export default {
    mixins: [price]
}
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';

.md-sold-detail.fashion .price-container {
    position: relative;
    .first-price {
        font-size: 30px;
        color: #8b93a7;
        font-family: var(--font-bold);
        display: inline-block;
    }
    .nodisclosure {
        .dollar {
            @include color-theme();
            font-size: 24px;
        }
        .secret {
            font-size: 12px;
            @include color-theme();
        }
        .des {
            font-size: 12px;
            color: #ff5661;
        }
    }
    .second-price {
        font-size: 14px;
        color: #8195bd;
        line-height: 16px;
        margin-top: 10px;
        display: inline-block;
        text-decoration: line-through;
        margin: 0 10px;
    }
    .trend {
        font-family: var(--font-bold);
        &.down {
            color: #ff5661;
        }
        &.up {
            color: #29cb97;
            .iconfont {
                transform: rotate(180deg);
            }
        }
        .iconfont {
            display: inline-block;
        }
    }
}
</style>
